// OWNER: Agent C. Green-up/red-down that also works for colour-blind users:
// an arrow glyph carries the direction, colour is secondary.
import { Badge } from "@cloudflare/kumo/components/badge";
import { ArrowUp, ArrowDown, Minus } from "@phosphor-icons/react";
import { formatPercent } from "@shared/format";

export function GainBadge({ pct }: { pct: number }) {
  if (!Number.isFinite(pct) || pct === 0) {
    return (
      <Badge variant="neutral" icon={<Minus size={12} weight="bold" />}>
        {formatPercent(0)}
      </Badge>
    );
  }
  const up = pct > 0;
  return (
    <Badge
      variant={up ? "success" : "error"}
      icon={up ? <ArrowUp size={12} weight="bold" /> : <ArrowDown size={12} weight="bold" />}
    >
      {formatPercent(pct)}
    </Badge>
  );
}
